// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__2C9hp","active":"Modal_active__188cU","modalContent":"Modal_modalContent__3tfZ7"};